var _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllufakos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 302,
    viewBox: "0 0 352 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5752_33455)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352 20.2854V107.309C352 118.032 343.137 126.889 332.407 126.889H136.479C125.749 126.889 116.886 118.032 116.886 107.309V20.2854C116.886 9.56285 125.749 0.705078 136.479 0.705078H332.407C343.292 0.705078 352 9.56285 352 20.2854Z",
    fill: "#E3E5FC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.233 26.8105V88.9703H299.908V26.8105H200.233ZM298.975 34.4251H292.444V27.8983H298.975V34.4251ZM201.477 73.4304H208.008V79.9572H201.477V73.4304ZM231.799 50.5867H238.33V57.1134H231.799V50.5867ZM230.711 57.1134H224.18V50.5867H230.711V57.1134ZM253.414 57.1134H246.883V50.5867H253.414V57.1134ZM254.502 50.5867H261.033V57.1134H254.502V50.5867ZM245.794 57.1134H239.263V50.5867H245.794V57.1134ZM238.175 58.2012V64.728H231.644V58.2012H238.175ZM239.263 58.2012H245.794V64.728H239.263V58.2012ZM246.883 58.2012H253.414V64.728H246.883V58.2012ZM254.502 58.2012H261.033V64.728H254.502V58.2012ZM262.122 58.2012H268.653V64.728H262.122V58.2012ZM262.122 57.1134V50.5867H268.653V57.1134H262.122ZM269.741 50.5867H276.272V57.1134H269.741V50.5867ZM269.741 49.4989V42.9721H276.272V49.4989H269.741ZM268.497 49.4989H261.966V42.9721H268.497V49.4989ZM261.033 49.4989H254.502V42.9721H261.033V49.4989ZM253.414 49.4989H246.883V42.9721H253.414V49.4989ZM245.794 49.4989H239.263V42.9721H245.794V49.4989ZM238.175 49.4989H231.644V42.9721H238.175V49.4989ZM230.711 49.4989H224.18V42.9721H230.711V49.4989ZM223.091 49.4989H216.561V42.9721H223.091V49.4989ZM223.091 50.5867V57.1134H216.561V50.5867H223.091ZM223.091 58.2012V64.728H216.561V58.2012H223.091ZM224.18 58.2012H230.711V64.728H224.18V58.2012ZM230.711 65.8158V72.3426H224.18V65.8158H230.711ZM231.799 65.8158H238.33V72.3426H231.799V65.8158ZM239.263 65.8158H245.794V72.3426H239.263V65.8158ZM246.883 65.8158H253.414V72.3426H246.883V65.8158ZM254.502 65.8158H261.033V72.3426H254.502V65.8158ZM262.122 65.8158H268.653V72.3426H262.122V65.8158ZM269.741 65.8158H276.272V72.3426H269.741V65.8158ZM269.741 64.728V58.2012H276.272V64.728H269.741ZM277.205 58.2012H283.736V64.728H277.205V58.2012ZM277.205 57.1134V50.5867H283.736V57.1134H277.205ZM277.205 49.4989V42.9721H283.736V49.4989H277.205ZM277.205 41.8843V35.3575H283.736V41.8843H277.205ZM276.116 41.8843H269.586V35.3575H276.116V41.8843ZM268.497 41.8843H261.966V35.3575H268.497V41.8843ZM261.033 41.8843H254.502V35.3575H261.033V41.8843ZM253.414 41.8843H246.883V35.3575H253.414V41.8843ZM245.794 41.8843H239.263V35.3575H245.794V41.8843ZM238.175 41.8843H231.644V35.3575H238.175V41.8843ZM230.711 41.8843H224.18V35.3575H230.711V41.8843ZM223.091 41.8843H216.561V35.3575H223.091V41.8843ZM215.472 41.8843H208.941V35.3575H215.472V41.8843ZM215.472 43.1275V49.6543H208.941V43.1275H215.472ZM215.472 50.5867V57.1134H208.941V50.5867H215.472ZM215.472 58.2012V64.728H208.941V58.2012H215.472ZM215.472 65.8158V72.3426H208.941V65.8158H215.472ZM216.561 65.8158H223.091V72.3426H216.561V65.8158ZM223.091 73.4304V79.9572H216.561V73.4304H223.091ZM224.18 73.4304H230.711V79.9572H224.18V73.4304ZM231.799 73.4304H238.33V79.9572H231.799V73.4304ZM239.263 73.4304H245.794V79.9572H239.263V73.4304ZM246.883 73.4304H253.414V79.9572H246.883V73.4304ZM254.502 73.4304H261.033V79.9572H254.502V73.4304ZM262.122 73.4304H268.653V79.9572H262.122V73.4304ZM269.741 73.4304H276.272V79.9572H269.741V73.4304ZM277.205 73.4304H283.736V79.9572H277.205V73.4304ZM277.205 72.3426V65.8158H283.736V72.3426H277.205ZM284.824 65.8158H291.355V72.3426H284.824V65.8158ZM284.824 64.728V58.2012H291.355V64.728H284.824ZM284.824 57.1134V50.5867H291.355V57.1134H284.824ZM284.824 49.4989V42.9721H291.355V49.4989H284.824ZM284.824 41.8843V35.3575H291.355V41.8843H284.824ZM284.824 34.4251V27.8983H291.355V34.4251H284.824ZM283.736 34.4251H277.205V27.8983H283.736V34.4251ZM276.116 34.4251H269.586V27.8983H276.116V34.4251ZM268.497 34.4251H261.966V27.8983H268.497V34.4251ZM261.033 34.4251H254.502V27.8983H261.033V34.4251ZM253.414 34.4251H246.883V27.8983H253.414V34.4251ZM245.794 34.4251H239.263V27.8983H245.794V34.4251ZM238.175 34.4251H231.644V27.8983H238.175V34.4251ZM230.711 34.4251H224.18V27.8983H230.711V34.4251ZM223.091 34.4251H216.561V27.8983H223.091V34.4251ZM215.472 34.4251H208.941V27.8983H215.472V34.4251ZM207.853 34.4251H201.322V27.8983H207.853V34.4251ZM201.477 35.5129H208.008V42.0397H201.477V35.5129ZM201.477 43.1275H208.008V49.6543H201.477V43.1275ZM201.477 50.5867H208.008V57.1134H201.477V50.5867ZM201.477 58.2012H208.008V64.728H201.477V58.2012ZM201.477 65.8158H208.008V72.3426H201.477V65.8158ZM208.941 73.4304H215.472V79.9572H208.941V73.4304ZM215.472 80.8896V87.7272H208.941V80.8896H215.472ZM216.561 80.8896H223.091V87.7272H216.561V80.8896ZM224.18 80.8896H230.711V87.7272H224.18V80.8896ZM231.799 80.8896H238.33V87.7272H231.799V80.8896ZM239.263 80.8896H245.794V87.7272H239.263V80.8896ZM246.883 80.8896H253.414V87.7272H246.883V80.8896ZM254.502 80.8896H261.033V87.7272H254.502V80.8896ZM262.122 80.8896H268.653V87.7272H262.122V80.8896ZM269.741 80.8896H276.272V87.7272H269.741V80.8896ZM277.205 80.8896H283.736V87.7272H277.205V80.8896ZM284.824 80.8896H291.355V87.7272H284.824V80.8896ZM284.824 79.8018V73.275H291.355V79.8018H284.824ZM292.444 73.4304H298.975V79.9572H292.444V73.4304ZM292.444 72.3426V65.8158H298.975V72.3426H292.444ZM292.444 64.728V58.2012H298.975V64.728H292.444ZM292.444 57.1134V50.5867H298.975V57.1134H292.444ZM292.444 49.4989V42.9721H298.975V49.4989H292.444ZM292.444 41.8843V35.3575H298.975V41.8843H292.444ZM201.477 80.8896H208.008V87.7272H201.477V80.8896ZM292.444 87.8825V81.045H298.975V87.8825H292.444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.121 80.8903L203.965 79.9579C205.987 79.6471 207.853 79.0255 209.408 78.0931C213.762 75.2959 215.161 70.6339 216.561 66.1273C217.96 61.6207 219.36 57.4249 223.247 55.5601C226.202 54.3169 229.156 54.9385 230.089 55.2493C234.91 56.6479 236.776 61.3099 238.486 65.8165C240.041 69.7015 241.441 73.2757 244.55 74.0527C246.727 74.6743 248.438 73.4311 250.615 72.0325C252.947 70.3231 255.902 68.3029 260.722 68.1475C264.765 67.9921 267.253 69.2353 269.43 70.3231C271.607 71.4109 273.162 72.1879 275.806 71.4109C278.605 70.6339 280.16 68.6137 281.87 66.2827C283.736 63.7963 285.913 60.9991 290.267 59.4451C292.289 58.6681 294.621 58.3573 296.954 58.5127V59.4451C294.777 59.2897 292.6 59.6005 290.578 60.3775C286.535 61.7761 284.514 64.4179 282.492 66.9043C280.782 69.2353 279.071 71.4109 275.961 72.3433C273.007 73.2757 270.985 72.1879 268.964 71.1001C266.942 70.0123 264.61 68.9245 260.722 69.0799C256.213 69.2353 253.569 71.2555 251.081 72.8095C248.904 74.3635 247.038 75.7621 244.395 74.9851C240.819 74.0527 239.264 70.1677 237.709 66.1273C235.998 61.9315 234.288 57.4249 229.934 56.1817C229.156 55.8709 226.357 55.2493 223.714 56.4925C220.137 58.0465 218.893 62.0869 217.494 66.4381C216.094 70.9447 214.539 76.0729 209.874 78.8701C208.319 79.8025 206.298 80.5795 204.121 80.8903Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.432 70.9439L203.81 70.3223C210.185 65.1941 216.716 62.397 223.558 61.9308C228.845 61.62 232.266 62.7077 235.065 63.6401C237.864 64.5725 240.196 65.3495 243.151 64.1063C247.971 62.2415 249.837 57.1134 252.014 51.8298C254.191 46.2354 256.524 40.3302 262.433 38.4654C263.366 38.1546 265.698 37.533 268.342 38.1546C273.784 39.5532 276.116 45.303 278.76 51.3636C281.248 57.4242 283.891 63.7955 289.8 66.2819C292.288 67.3697 295.087 67.6805 298.197 67.2143L298.353 68.1467C295.087 68.6129 292.133 68.3021 289.489 67.2143C283.269 64.5725 280.626 58.0458 277.982 51.8298C275.494 45.9246 273.317 40.3302 268.186 39.087C265.698 38.4654 263.677 39.087 262.744 39.3978C257.146 41.1072 255.124 46.3908 252.792 52.1406C250.77 57.4242 248.593 62.8631 243.462 64.8833C240.196 66.1265 237.708 65.3495 234.909 64.4171C232.11 63.4847 228.845 62.397 223.713 62.7078C217.027 63.3293 210.496 65.9711 204.432 70.9439Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.005 35.824H334.584V62.0865H331.163V35.824H327.742C329.452 32.716 331.163 29.608 332.873 26.5C334.584 29.608 336.294 32.716 338.005 35.824Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.811 40.4861H316.39V62.0866H312.969V40.4861H309.548C311.259 37.3781 312.969 34.2701 314.68 31.1621C316.39 34.4255 318.101 37.5335 319.811 40.4861Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.731 26.5H170.222V31.0066H174.731V26.5Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.506 26.5H177.997V31.0066H182.506V26.5Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.731 34.4258H170.222V38.9324H174.731V34.4258Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.506 34.4258H177.997V38.9324H182.506V34.4258Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.321 42.1953H138.811V46.7019H143.321V42.1953Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.731 42.1953H170.222V46.7019H174.731V42.1953Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.506 42.1953H177.997V46.7019H182.506V42.1953Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.731 49.9648H170.222V54.4714H174.731V49.9648Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.506 49.9648H177.997V54.4714H182.506V49.9648Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.801 26.5H162.291V31.0066H166.801V26.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.546 34.4258H131.036V38.9324H135.546V34.4258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.321 34.4258H138.811V38.9324H143.321V34.4258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.251 34.4258H146.741V38.9324H151.251V34.4258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.026 34.4258H154.516V38.9324H159.026V34.4258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.801 34.4258H162.291V38.9324H166.801V34.4258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.546 42.1953H131.036V46.7019H135.546V42.1953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.251 42.1953H146.741V46.7019H151.251V42.1953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.026 42.1953H154.516V46.7019H159.026V42.1953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.801 42.1953H162.291V46.7019H166.801V42.1953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.546 49.9648H131.036V54.4714H135.546V49.9648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.321 49.9648H138.811V54.4714H143.321V49.9648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.251 49.9648H146.741V54.4714H151.251V49.9648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.026 49.9648H154.516V54.4714H159.026V49.9648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.801 49.9648H162.291V54.4714H166.801V49.9648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.546 57.8906H131.036V62.3972H135.546V57.8906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.321 57.8906H138.811V62.3972H143.321V57.8906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.251 57.8906H146.741V62.3972H151.251V57.8906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.026 57.8906H154.516V62.3972H159.026V57.8906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.801 57.8906H162.291V62.3972H166.801V57.8906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.251 26.5H146.741V31.0066H151.251V26.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.026 26.5H154.516V31.0066H159.026V26.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.005 77.1602H309.704V78.2479H338.005V77.1602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.005 81.9785H309.704V83.0663H338.005V81.9785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.608 86.9512H309.704V88.039H329.608V86.9512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.005 67.3711H309.704V68.4589H338.005V67.3711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.005 72.1875H309.704V73.2753H338.005V72.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.94 12.6699H131.036V13.7577H150.94V12.6699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.691 16.4004H131.036V17.4882H163.691V16.4004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.759 12.6699H200.855V13.7577H220.759V12.6699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.51 16.4004H200.855V17.4882H233.51V16.4004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.146 96.5859H309.548V102.18H315.146V96.5859Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.005 98.916H318.567V100.004H338.005V98.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.146 108.861H309.548V114.456H315.146V108.861Z",
    fill: "#9C9CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.005 111.037H318.567V112.125H338.005V111.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.05 187.496H31.0507C23.8977 187.496 18.1443 181.746 18.1443 174.598V76.2302C18.1443 69.0818 23.8977 63.332 31.0507 63.332H277.205C284.358 63.332 290.111 69.0818 290.111 76.2302V174.598C289.956 181.746 284.203 187.496 277.05 187.496Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.202 95.1875H32.4502V97.8293H103.202V95.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.202 108.553H32.4502V111.195H103.202V108.553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.202 122.072H32.4502V124.714H103.202V122.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3438 95.1875H32.4502V97.8293H80.3438V95.1875Z",
    fill: "url(#paint0_linear_5752_33455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.086 108.553H32.4502V111.195H56.086V108.553Z",
    fill: "url(#paint1_linear_5752_33455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1024 122.072H32.4502V124.714H72.1024V122.072Z",
    fill: "url(#paint2_linear_5752_33455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.129 90.3711H32.4502V91.4589H60.129V90.3711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.129 103.734H32.4502V104.822H60.129V103.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.129 117.1H32.4502V118.187H60.129V117.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.354 75.7637H32.4502V76.8515H52.354V75.7637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1049 79.3379H32.4502V80.4257H65.1049V79.3379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.458 115.855H118.597V116.943H134.458V115.855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.72 119.43H118.597V120.517H144.72V119.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.597 115.855H160.737V116.943H176.597V115.855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.86 119.43H160.737V120.517H186.86V119.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.737 115.855H202.876V116.943H218.737V115.855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 119.43H202.876V120.517H229V119.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.878 115.545H245.017V116.633H260.878V115.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.141 119.275H245.017V120.363H271.141V119.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.72 123.004H118.597V124.092H144.72V123.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.86 123.004H160.737V124.092H186.86V123.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 123.004H202.876V124.092H229V123.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.141 122.85H245.017V123.937H271.141V122.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.458 105.755C125.283 105.755 117.819 98.2963 117.819 89.1277C117.819 79.9592 125.283 72.5 134.458 72.5C143.632 72.5 151.096 79.9592 151.096 89.1277C150.94 98.2963 143.476 105.755 134.458 105.755ZM134.458 74.2094C126.216 74.2094 119.53 80.8916 119.53 89.1277C119.53 97.3639 126.216 104.046 134.458 104.046C142.699 104.046 149.385 97.3639 149.385 89.1277C149.385 80.8916 142.699 74.2094 134.458 74.2094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.12 79.9592C143.321 76.385 138.967 74.2094 134.458 74.2094V72.5C139.589 72.5 144.254 74.831 147.52 78.8714L146.12 79.9592Z",
    fill: "url(#paint3_linear_5752_33455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.442 105.755C167.268 105.755 159.804 98.2963 159.804 89.1277C159.804 79.9592 167.268 72.5 176.442 72.5C185.617 72.5 193.081 79.9592 193.081 89.1277C193.081 98.2963 185.617 105.755 176.442 105.755ZM176.442 74.2094C168.201 74.2094 161.514 80.8916 161.514 89.1277C161.514 97.3639 168.201 104.046 176.442 104.046C184.684 104.046 191.37 97.3639 191.37 89.1277C191.37 80.8916 184.684 74.2094 176.442 74.2094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.081 89.1277H191.37C191.37 80.8916 184.684 74.2094 176.442 74.2094V72.5C185.617 72.6554 193.081 79.9592 193.081 89.1277Z",
    fill: "url(#paint4_linear_5752_33455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.582 105.755C209.408 105.755 201.944 98.2963 201.944 89.1277C201.944 79.9592 209.408 72.5 218.582 72.5C227.757 72.5 235.22 79.9592 235.22 89.1277C235.22 98.2963 227.757 105.755 218.582 105.755ZM218.582 74.2094C210.341 74.2094 203.654 80.8916 203.654 89.1277C203.654 97.3639 210.341 104.046 218.582 104.046C226.824 104.046 233.51 97.3639 233.51 89.1277C233.51 80.8916 226.824 74.2094 218.582 74.2094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.582 105.755V104.046C226.824 104.046 233.51 97.3639 233.51 89.1277C233.51 80.8916 226.824 74.2094 218.582 74.2094V72.5C227.757 72.5 235.221 79.9592 235.221 89.1277C235.221 98.2963 227.757 105.755 218.582 105.755Z",
    fill: "url(#paint5_linear_5752_33455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.722 105.755C251.548 105.755 244.084 98.2963 244.084 89.1277C244.084 79.9592 251.548 72.5 260.722 72.5C269.896 72.5 277.36 79.9592 277.36 89.1277C277.36 98.2963 269.896 105.755 260.722 105.755ZM260.722 74.2094C252.481 74.2094 245.794 80.8916 245.794 89.1277C245.794 97.3639 252.481 104.046 260.722 104.046C268.963 104.046 275.65 97.3639 275.65 89.1277C275.65 80.8916 268.963 74.2094 260.722 74.2094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.722 105.755C251.548 105.755 244.084 98.2963 244.084 89.1277H245.794C245.794 97.3639 252.481 104.046 260.722 104.046C268.963 104.046 275.65 97.3639 275.65 89.1277C275.65 80.8916 268.963 74.2094 260.722 74.2094V72.5C269.896 72.5 277.36 79.9592 277.36 89.1277C277.36 98.2963 269.896 105.755 260.722 105.755Z",
    fill: "url(#paint6_linear_5752_33455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.062 137.146H32.4502V138.234H61.062V137.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.062 141.965H32.4502V143.053H61.062V141.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.062 146.938H32.4502V148.025H61.062V146.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.062 151.754H32.4502V152.842H61.062V151.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.062 156.727H32.4502V157.814H61.062V156.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.062 161.545H32.4502V162.633H61.062V161.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.736 137.146H74.1238V138.234H102.736V137.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.736 141.963H74.1238V143.051H102.736V141.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.736 146.938H74.1238V148.025H102.736V146.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.736 151.754H74.1238V152.842H102.736V151.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.736 156.727H74.1238V157.814H102.736V156.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.736 161.545H74.1238V162.633H102.736V161.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.926 169.78C137.878 166.516 141.61 172.577 151.873 171.334C165.09 169.78 170.999 157.969 182.662 158.746C186.238 159.057 188.57 159.523 188.57 159.523C193.857 160.766 195.723 162.787 200.544 163.564C202.721 163.874 204.431 163.719 205.831 163.719C218.737 162.787 225.89 153.307 238.952 152.841C239.885 152.841 244.239 152.686 249.37 154.55C258.545 157.814 264.298 164.807 267.719 168.847C269.896 171.489 271.451 173.975 272.384 175.529C238.33 175.529 135.856 175.529 118.596 175.529C120.618 173.665 123.572 171.178 127.926 169.78Z",
    fill: "url(#paint7_linear_5752_33455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.738 176.618H118.13V138.545H119.218V175.53H276.738V176.618Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5752_33455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.333 170.825L337.564 194.758C340.627 195.768 342.265 199.333 341.101 202.499L340.916 203.027C339.891 205.824 336.877 207.149 334.251 206.016L262.735 175.144L265.333 170.825Z",
    fill: "url(#paint8_linear_5752_33455)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M270.24 155.75C270.044 138.055 255.251 123.874 237.197 124.077C219.143 124.279 204.667 138.788 204.862 156.483C205.058 174.178 219.852 188.359 237.906 188.157C255.959 187.954 270.436 173.445 270.24 155.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.171 156.515C201.398 176.189 217.856 191.966 237.942 191.747C258.029 191.526 274.146 175.378 273.946 155.702C273.719 136.028 257.261 120.25 237.148 120.472C217.062 120.692 200.945 136.841 201.171 156.515ZM206.506 156.466C206.326 139.672 220.072 125.885 237.218 125.688C254.364 125.491 268.405 138.959 268.585 155.753C268.765 172.546 255.018 186.308 237.872 186.504C220.752 186.7 206.686 173.259 206.506 156.466Z",
    fill: "url(#paint9_linear_5752_33455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.217 160.027C271.14 160.03 271.11 159.953 271.108 159.902C271.202 159.067 271.269 158.207 271.311 157.374C271.308 157.296 271.383 157.241 271.437 157.265C271.514 157.261 271.57 157.337 271.546 157.39C271.505 158.248 271.438 159.108 271.344 159.943C271.345 159.969 271.296 160.023 271.217 160.027ZM270.73 149.972C270.294 147.706 269.625 145.475 268.726 143.359C266.175 137.341 261.894 132.254 256.348 128.625C250.668 124.898 244.05 122.951 237.182 123.04C230.729 123.112 224.484 124.966 219.115 128.419C219.064 128.447 218.986 128.45 218.931 128.375C218.903 128.324 218.899 128.246 218.975 128.191C224.396 124.736 230.692 122.854 237.171 122.781C244.066 122.717 250.761 124.634 256.468 128.386C262.041 132.04 266.35 137.177 268.955 143.245C269.855 145.387 270.55 147.617 270.988 149.909C270.991 149.987 270.968 150.04 270.89 150.043C270.89 150.043 270.89 150.043 270.864 150.044C270.812 150.072 270.758 150.023 270.73 149.972Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.669 204.744C336.695 204.743 336.695 204.743 336.721 204.742C338.894 203.816 340.004 202.418 339.977 200.575C339.949 198.733 338.783 197.069 337.012 196.445L328.207 193.268C328.102 193.247 327.999 193.277 327.977 193.382C327.956 193.487 327.986 193.589 328.093 193.637L336.897 196.788C338.484 197.368 339.591 198.878 339.586 200.567C339.605 202.227 338.594 203.518 336.574 204.358C336.471 204.389 336.425 204.521 336.481 204.622C336.51 204.698 336.591 204.747 336.669 204.744Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 237.508,
    cy: 155.969,
    rx: 31.2726,
    ry: 30.4274,
    transform: "rotate(-2.47822 237.508 155.969)",
    fill: "white",
    fillOpacity: 0.7
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5752_33455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.579 181.867C276.086 182.966 277.269 183.051 278.03 183.98C278.368 184.403 278.706 184.995 278.791 186.009C279.805 186.093 280.819 186.093 281.833 186.178C281.918 185.502 282.002 184.91 282.087 184.572C282.087 184.319 282.171 184.065 282.256 183.727C282.34 183.304 282.34 182.882 282.425 182.375C282.425 181.614 282.34 181.191 282.087 181.022C282.087 181.022 281.749 180.769 281.411 180.853C281.411 180.853 281.326 180.938 281.157 181.107C280.904 181.529 281.157 181.783 280.988 182.121C280.904 182.29 280.819 182.459 280.312 182.713C278.706 182.036 277.1 181.36 275.41 180.6C275.41 180.938 275.41 181.36 275.579 181.867Z",
    fill: "#F7B690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.149 199.616C316.149 199.954 316.149 200.377 315.98 200.969C316.825 201.476 317.585 201.983 318.431 202.49C318.515 202.236 318.684 202.067 318.853 201.898C318.938 201.729 319.191 201.476 319.614 201.307C320.544 200.884 321.135 201.645 322.403 201.391C322.741 201.307 322.995 201.222 323.164 201.138C321.22 200.292 319.276 199.447 317.332 198.602C317.332 198.433 317.332 198.179 317.332 197.841C317.332 197.334 317.416 197.165 317.247 196.996C317.078 196.743 316.74 196.658 316.487 196.743C316.318 196.827 316.149 196.996 316.064 197.419C315.98 197.672 315.98 197.926 315.98 198.01C315.98 198.095 315.98 198.179 315.98 198.179C315.98 198.771 316.064 199.194 316.149 199.616Z",
    fill: "#F7B690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.933 210.266C289.525 210.857 290.201 211.026 290.201 211.026C290.792 211.195 291.3 211.195 291.638 211.195L291.469 213.308C291.638 213.477 292.398 213.985 293.413 213.985C294.258 213.9 294.849 213.477 295.103 213.308C295.188 212.632 295.188 212.21 295.272 211.872H295.188C295.019 211.872 294.934 211.872 294.849 211.872C294.511 211.956 294.342 211.872 294.258 211.787C293.666 211.449 293.666 210.097 294.258 208.322C294.258 208.322 294.849 208.744 295.441 208.575C295.526 208.575 295.948 208.406 296.117 207.899C296.286 207.392 296.117 206.8 295.779 206.631C295.357 206.378 294.849 206.8 294.596 206.631C294.173 206.209 296.117 204.011 295.526 202.997C295.188 202.49 294.427 202.743 292.314 202.405C290.877 202.152 289.947 201.983 289.356 201.645C287.665 204.772 287.834 209.167 288.933 210.266Z",
    fill: "#F7B690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.933 201.222C289.018 201.476 289.187 201.645 289.44 201.729C290.032 202.067 290.962 202.236 292.398 202.49C294.511 202.828 295.272 202.575 295.61 203.082C296.202 204.096 294.258 206.293 294.68 206.716C294.934 206.885 295.441 206.462 295.864 206.716C296.202 206.885 296.371 207.477 296.202 207.984C296.033 208.491 295.526 208.66 295.526 208.66C294.934 208.914 294.342 208.406 294.342 208.406C294.004 209.252 293.92 210.012 293.92 210.604C293.92 210.942 294.004 211.534 294.342 211.787C294.68 212.041 295.188 211.872 295.357 211.787C296.455 211.449 297.892 209.759 298.568 207.223C299.583 203.251 297.808 200.208 297.301 199.785C297.047 199.532 296.793 199.447 296.709 199.363C295.948 198.856 295.272 198.771 294.511 198.687H294.427C294.342 198.687 294.258 198.687 294.173 198.687C294.089 198.687 294.004 198.687 294.004 198.687C293.328 198.602 292.483 198.602 291.384 198.349C290.708 198.179 290.454 198.095 290.116 198.264C289.102 198.602 288.426 200.208 288.933 201.222Z",
    fill: "#2D2169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.608 241.961C283.777 259.203 283.862 278.812 284.031 296.054H288.257C289.947 284.644 291.638 272.219 293.328 260.133C295.526 272.219 298.146 284.559 299.667 295.969H304.147C303.809 277.967 303.555 259.964 303.302 241.961C296.709 241.961 290.201 241.961 283.608 241.961Z",
    fill: "#433082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.934 301.041C294.934 301.21 295.103 301.295 295.188 301.295H303.301C303.471 301.295 303.555 301.126 303.555 301.041V296.055H300.428C300.428 296.139 300.428 296.224 300.428 296.308C300.512 297.492 300.512 297.83 300.343 298.168C300.005 298.759 299.414 298.928 298.484 299.351C297.639 299.689 296.455 300.112 295.018 300.788C295.018 300.788 294.934 300.957 294.934 301.041Z",
    fill: "#F7B690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.64 300.957C303.64 301.126 303.471 301.211 303.386 301.211H295.272C295.103 301.211 295.019 301.126 295.019 300.957C295.019 300.788 295.019 300.704 295.188 300.619C296.624 299.943 297.808 299.436 298.653 299.182C298.653 299.182 298.737 299.182 298.737 299.098H303.724V300.957H303.64Z",
    fill: "#2D2169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.044 301.041C279.044 301.21 279.213 301.294 279.298 301.294H287.412C287.581 301.294 287.665 301.125 287.665 301.041V296.139H284.538V296.308C284.454 297.745 284.369 298.083 284.2 298.336C283.862 298.843 283.439 299.012 282.594 299.35C281.749 299.689 279.636 300.618 279.129 300.787C279.044 300.787 279.044 300.956 279.044 301.041Z",
    fill: "#F7B690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.665 300.957C287.665 301.126 287.496 301.211 287.412 301.211H279.298C279.129 301.211 279.044 301.126 279.044 300.957C279.044 300.788 279.044 300.704 279.213 300.619C279.72 300.365 281.833 299.436 282.679 299.182C282.679 299.182 282.763 299.182 282.763 299.098H287.665V300.957Z",
    fill: "#2D2169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.368 186.01C278.368 188.545 278.453 196.828 279.551 204.013C280.058 207.647 281.157 211.028 281.157 211.028C281.326 211.704 281.495 212.296 281.664 212.718C281.918 213.648 282.171 214.24 282.171 214.409C282.763 216.099 283.017 218.55 283.017 219.226C283.439 223.706 283.355 226.664 283.355 226.664C283.27 230.721 283.355 234.102 283.439 241.962C289.609 241.962 296.878 241.878 303.048 241.878C302.71 236.553 302.456 231.82 302.287 227.763C302.203 226.58 302.203 224.805 303.048 222.861C304.062 220.579 305.837 219.226 307.02 218.55C307.02 218.55 310.655 216.606 314.036 212.549C315.557 210.943 317.755 207.816 318.769 202.745C318.684 202.66 318.515 202.576 318.431 202.491C317.586 201.984 315.642 200.716 315.473 200.632C315.05 202.322 313.275 208.661 307.443 212.127C306.006 212.972 302.71 215 298.484 214.24C297.047 213.986 295.864 213.479 295.103 213.056C294.934 213.225 294.342 213.732 293.413 213.817C292.314 213.902 291.553 213.31 291.469 213.141C290.793 213.141 289.694 213.141 288.68 212.549C287.074 211.704 286.397 210.183 285.806 208.83C283.862 203.759 282.763 195.899 282.594 194.462C282.425 193.448 282.256 192.349 282.171 191.081C282.087 189.137 282.171 187.447 282.34 186.01C282.171 186.01 282.002 186.01 281.833 186.01C280.904 186.094 278.537 186.01 278.368 186.01Z",
    fill: "#FB911B"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_5752_33455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.566 186.027C118.428 187.269 117.598 188.116 116.585 187.833C115.893 187.664 115.294 186.817 115.248 185.914C115.064 185.406 115.156 184.785 115.34 184.221C115.571 183.543 116.262 183.204 116.815 183.148C118.013 183.092 118.704 184.672 118.566 186.027Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0304 186.365C39.7216 186.647 40.1363 187.325 40.1363 188.228C40.1363 189.018 39.7216 189.639 39.2608 190.091C38.2931 190.994 36.4959 189.922 36.8185 188.341C36.8646 188.115 36.9567 187.889 37.0489 187.72C37.3715 186.76 38.247 186.026 39.0304 186.365Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.734 215.212C70.734 215.325 70.6879 215.438 70.6879 215.551C70.6879 215.607 70.6879 215.664 70.6879 215.72C70.6879 215.777 70.6879 215.777 70.6879 215.833C70.5497 216.793 70.2271 217.583 69.4898 218.035C68.7986 218.486 68.1535 218.317 67.5083 217.752C65.8494 216.228 67.1858 212.672 69.2133 213.123C69.2594 213.123 69.3055 213.18 69.3516 213.18C70.1349 213.406 70.6879 214.252 70.734 215.212Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3226 227.857C98.0138 227.857 98.5207 228.365 98.7511 229.156C98.8433 229.438 98.8433 229.72 98.8894 230.059C98.8894 230.115 98.8433 230.228 98.8433 230.285C98.8433 230.341 98.8433 230.341 98.8433 230.398C98.7972 230.567 98.7972 230.793 98.705 230.906C98.659 231.019 98.6129 231.075 98.5668 231.188C98.5207 231.301 98.4746 231.357 98.3825 231.414C98.2903 231.527 98.1981 231.583 98.106 231.64C98.0138 231.696 97.9677 231.753 97.8756 231.809C97.8295 231.809 97.8295 231.865 97.7834 231.865C97.6452 231.922 97.553 231.922 97.4148 231.922C97.4148 231.922 97.4148 231.922 97.3687 231.922C97 231.922 96.7236 231.809 96.4471 231.583C96.4471 231.583 96.401 231.583 96.401 231.527C96.3549 231.527 96.3549 231.47 96.3088 231.47C95.9863 231.132 95.7559 230.68 95.7559 230.115C95.7559 230.003 95.7559 229.946 95.8019 229.833C95.8019 229.777 95.8019 229.72 95.8019 229.607V229.551C95.848 229.269 95.8941 229.043 95.9863 228.761C96.2627 228.253 96.8618 227.914 97.3226 227.857Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9133 184.389C84.7428 184.389 85.2497 185.631 84.7428 186.364C84.5585 186.76 84.1437 186.985 83.729 186.873C83.6829 186.873 83.6829 186.873 83.6368 186.816C83.5908 186.816 83.5447 186.76 83.5447 186.76C83.3604 186.647 83.2221 186.477 83.1299 186.252C82.7152 185.518 83.0839 184.389 83.9133 184.389Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6088 126.582C92.1618 126.469 92.7147 126.977 92.9912 127.542C93.3138 128.163 93.2677 128.784 93.0373 129.461C92.9451 129.687 92.8069 129.913 92.6687 130.082C92.6226 130.139 92.6226 130.139 92.5765 130.195C92.5304 130.252 92.5304 130.252 92.5304 130.252C92.2539 130.929 91.5166 131.211 90.9176 131.042C90.2264 130.816 89.8577 130.195 89.8116 129.405C89.6734 128.897 89.6734 128.332 89.9038 127.881C90.3185 127.034 90.8715 126.752 91.6088 126.582Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.516 153.171C99.2121 153.171 99.1199 148.768 101.424 148.768C103.728 148.824 103.82 153.171 101.516 153.171Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.732 103.043C108.612 103.043 108.52 99.0352 110.64 99.0352C112.76 99.0352 112.806 103.043 110.732 103.043Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6139 100.275C76.402 100.275 76.3099 96.0416 78.5217 96.0416C80.7336 95.9851 80.8258 100.275 78.6139 100.275Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1819 103.721C48.2926 103.721 48.2465 100.164 50.1359 100.164C51.9791 100.164 52.0713 103.721 50.1819 103.721Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9981 124.607C37.1872 124.607 37.0489 119.244 39.906 119.244C42.7169 119.244 42.8091 124.607 39.9981 124.607Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35023 106.372C0.691316 106.372 0.645236 103.211 2.30415 103.211C3.96306 103.211 4.00914 106.372 2.35023 106.372Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4964 175.639C24.3306 175.639 24.2384 171.518 26.4042 171.518C28.57 171.462 28.6622 175.639 26.4964 175.639Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.31782 149.05C3.3639 150.405 2.3962 151.647 1.29026 151.647C0.829455 151.647 0.368647 151.478 0 151.139V147.018C0.322566 146.736 0.737293 146.51 1.15202 146.51C2.30404 146.566 3.27174 147.639 3.31782 149.05Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9391 218.146C21.0128 218.146 21.1049 222.098 19.0313 222.098C16.9576 222.098 16.8655 218.146 18.9391 218.146Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3435 215.324C45.8504 214.308 47.0024 214.195 47.5554 215.268C47.5554 215.268 47.5554 215.324 47.6015 215.324C47.6476 215.381 47.6936 215.437 47.7397 215.55C47.9701 216.002 47.9701 216.623 47.7858 217.018C47.5554 217.47 47.2789 217.808 46.8642 217.921C45.7582 218.204 44.6523 216.849 45.2514 215.494C45.2514 215.494 45.2974 215.437 45.3435 215.324Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9199 238.244C42.3945 238.244 42.9014 240.051 42.4867 241.293H39.4453C38.9845 240.051 39.4453 238.244 40.9199 238.244Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66312 194.381C10.6907 194.381 10.7368 198.22 8.75528 198.22C6.72772 198.163 6.63556 194.381 8.66312 194.381Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4718 148.26C64.0523 148.26 64.1905 153.227 61.5639 153.227C58.9834 153.171 58.8451 148.26 61.4718 148.26Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 231.751V228.025C1.79715 228.195 1.84323 231.638 0 231.751Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0756 178.179C59.306 177.727 59.7668 177.332 60.2276 177.558C60.2737 177.558 60.3198 177.614 60.3659 177.614C61.2875 178.009 61.3796 179.533 60.4119 179.929C60.3659 179.929 60.3198 179.985 60.2737 179.985C59.859 180.154 59.306 179.872 59.1217 179.421C58.9374 179.082 58.8913 178.63 59.0756 178.292C59.0295 178.235 59.0756 178.179 59.0756 178.179Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2152 208.776C29.2152 208.719 29.2613 208.719 29.2613 208.663C29.4917 208.211 29.9525 207.816 30.4133 208.042C30.4594 208.042 30.5055 208.098 30.5516 208.098C31.4732 208.494 31.5653 210.018 30.5976 210.413C30.5516 210.413 30.5055 210.469 30.4594 210.469C30.0447 210.639 29.4917 210.357 29.3074 209.905C29.1231 209.566 29.0309 209.115 29.2152 208.776Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1644 148.485C32.1644 148.428 32.2105 148.428 32.2105 148.372C32.4409 147.92 32.9017 147.525 33.3625 147.751C33.4086 147.751 33.4547 147.807 33.5008 147.807C34.4224 148.203 34.5146 149.727 33.5469 150.122C33.5008 150.122 33.4547 150.178 33.4086 150.178C32.9939 150.348 32.4409 150.066 32.2566 149.614C32.0723 149.275 31.9801 148.88 32.1644 148.485Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1109 89.9462C95.0648 89.9462 95.0188 90.0027 94.9727 90.0027C94.5579 90.172 94.005 89.8898 93.8206 89.4381C93.6363 89.0994 93.5902 88.6478 93.7746 88.3091C93.7746 88.2527 93.8206 88.2527 93.8206 88.1962C94.0511 87.7446 94.5119 87.3494 94.9727 87.5752C95.0188 87.5752 95.0648 87.6317 95.1109 87.6317C95.9864 88.0269 96.1247 89.4946 95.1109 89.9462Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.626 216.679C119.856 216.227 120.317 215.832 120.778 216.058C120.824 216.058 120.87 216.114 120.916 216.114C121.838 216.509 121.93 218.033 120.962 218.429C120.916 218.429 120.87 218.485 120.824 218.485C120.409 218.654 119.856 218.372 119.672 217.921C119.488 217.582 119.442 217.13 119.626 216.792C119.58 216.735 119.58 216.735 119.626 216.679Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0119 82.4941C40.2285 82.4941 39.7216 81.986 39.4912 81.3086H42.5325C42.2561 81.986 41.7953 82.4941 41.0119 82.4941Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.764 149.219C129.764 148.373 130.086 147.582 130.639 147.074V151.195C130.132 150.744 129.764 150.01 129.764 149.219Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.455 228.025C130.501 228.025 130.547 228.025 130.593 228.025V231.751C130.547 231.751 130.547 231.751 130.501 231.751C128.566 231.751 128.519 228.025 130.455 228.025Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_5752_33455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.1314 172.024C62.7932 172.294 63.1902 172.942 63.1902 173.807C63.1902 174.564 62.7932 175.158 62.352 175.591C61.4256 176.455 59.7051 175.428 60.0139 173.915C60.058 173.699 60.1462 173.483 60.2345 173.321C60.5433 172.402 61.3815 171.699 62.1314 172.024Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4827 199.641C92.4827 199.749 92.4386 199.857 92.4386 199.965C92.4386 200.019 92.4386 200.073 92.4386 200.127C92.4386 200.181 92.4386 200.181 92.4386 200.235C92.3062 201.154 91.9974 201.911 91.2916 202.343C90.6299 202.775 90.0122 202.613 89.3946 202.073C87.8065 200.614 89.0858 197.209 91.0269 197.641C91.071 197.641 91.1151 197.695 91.1592 197.695C91.9092 197.911 92.4386 198.722 92.4827 199.641Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.937 211.746C118.599 211.746 119.084 212.232 119.305 212.989C119.393 213.259 119.393 213.53 119.437 213.854C119.437 213.908 119.393 214.016 119.393 214.07C119.393 214.124 119.393 214.124 119.393 214.178C119.349 214.34 119.349 214.556 119.261 214.664C119.217 214.773 119.172 214.827 119.128 214.935C119.084 215.043 119.04 215.097 118.952 215.151C118.864 215.259 118.775 215.313 118.687 215.367C118.599 215.421 118.555 215.475 118.467 215.529C118.422 215.529 118.422 215.583 118.378 215.583C118.246 215.637 118.158 215.637 118.025 215.637C118.025 215.637 118.025 215.637 117.981 215.637C117.628 215.637 117.364 215.529 117.099 215.313C117.099 215.313 117.055 215.313 117.055 215.259C117.011 215.259 117.011 215.205 116.967 215.205C116.658 214.881 116.437 214.448 116.437 213.908C116.437 213.8 116.437 213.746 116.481 213.638C116.481 213.584 116.481 213.53 116.481 213.421V213.367C116.525 213.097 116.57 212.881 116.658 212.611C116.923 212.124 117.496 211.8 117.937 211.746Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.1 170.133C105.894 170.133 106.379 171.322 105.894 172.024C105.717 172.403 105.32 172.619 104.923 172.511C104.879 172.511 104.879 172.511 104.835 172.457C104.791 172.457 104.747 172.403 104.747 172.403C104.57 172.295 104.438 172.132 104.35 171.916C103.953 171.214 104.306 170.133 105.1 170.133Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.467 114.793C112.996 114.684 113.526 115.171 113.79 115.711C114.099 116.306 114.055 116.9 113.834 117.549C113.746 117.765 113.614 117.981 113.481 118.143C113.437 118.197 113.437 118.197 113.393 118.251C113.349 118.305 113.349 118.305 113.349 118.305C113.084 118.954 112.379 119.224 111.805 119.062C111.143 118.846 110.79 118.251 110.746 117.495C110.614 117.008 110.614 116.468 110.835 116.036C111.232 115.225 111.761 114.955 112.467 114.793Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.952 140.247C119.746 140.247 119.658 136.031 121.863 136.031C124.069 136.085 124.157 140.247 121.952 140.247Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.775 92.2551C128.745 92.2551 128.657 88.418 130.686 88.418C132.716 88.418 132.76 92.2551 130.775 92.2551Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.026 89.6085C97.9087 89.6085 97.8205 85.5552 99.938 85.5552C102.056 85.5012 102.144 89.6085 100.026 89.6085Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8073 92.9047C70.9985 92.9047 70.9544 89.5 72.7632 89.5C74.5278 89.5 74.616 92.9047 72.8073 92.9047Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0578 112.9C60.3668 112.9 60.2344 107.766 62.9696 107.766C65.6606 107.766 65.7488 112.9 63.0578 112.9Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0154 95.4444C25.4273 95.4444 25.3831 92.418 26.9713 92.418C28.5594 92.418 28.6036 95.4444 27.0154 95.4444Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1319 161.756C48.0584 161.756 47.9702 157.811 50.0436 157.811C52.1171 157.757 52.2053 161.756 50.1319 161.756Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9419 136.301C27.986 137.598 27.0596 138.787 26.0009 138.787C25.5597 138.787 25.1185 138.625 24.7656 138.301V134.356C25.0744 134.085 25.4715 133.869 25.8685 133.869C26.9714 133.923 27.8978 134.95 27.9419 136.301Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8969 202.451C44.8821 202.451 44.9704 206.234 42.9852 206.234C41 206.234 40.9117 202.451 42.8969 202.451Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1752 199.749C68.6604 198.776 69.7633 198.668 70.2927 199.695C70.2927 199.695 70.2927 199.749 70.3368 199.749C70.3809 199.803 70.4251 199.857 70.4692 199.965C70.6897 200.397 70.6897 200.992 70.5133 201.37C70.2927 201.802 70.028 202.127 69.631 202.235C68.5722 202.505 67.5134 201.208 68.0869 199.911C68.0869 199.911 68.1311 199.857 68.1752 199.749Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.94 221.689C65.3517 221.689 65.837 223.419 65.44 224.608H62.5283C62.0872 223.419 62.5283 221.689 63.94 221.689Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0594 179.699C35.0005 179.699 35.0446 183.374 33.1476 183.374C31.2066 183.32 31.1183 179.699 33.0594 179.699Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6155 135.545C86.0859 135.545 86.2183 140.301 83.7037 140.301C81.2333 140.247 81.1009 135.545 83.6155 135.545Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7656 215.475V211.908C26.4861 212.07 26.5302 215.367 24.7656 215.475Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3213 164.188C81.5419 163.756 81.983 163.378 82.4242 163.594C82.4683 163.594 82.5124 163.648 82.5565 163.648C83.4389 164.026 83.5271 165.485 82.6007 165.864C82.5565 165.864 82.5124 165.918 82.4683 165.918C82.0713 166.08 81.5419 165.81 81.3654 165.377C81.189 165.053 81.1449 164.621 81.3213 164.297C81.2772 164.242 81.3213 164.188 81.3213 164.188Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7346 193.48C52.7346 193.426 52.7787 193.426 52.7787 193.372C52.9993 192.94 53.4405 192.561 53.8816 192.778C53.9257 192.778 53.9698 192.832 54.014 192.832C54.8963 193.21 54.9845 194.669 54.0581 195.047C54.014 195.047 53.9698 195.101 53.9257 195.101C53.5287 195.264 52.9993 194.993 52.8228 194.561C52.6464 194.237 52.5582 193.804 52.7346 193.48Z",
    fill: "#E3E5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5581 135.761C55.5581 135.707 55.6022 135.707 55.6022 135.653C55.8228 135.221 56.2639 134.843 56.7051 135.059C56.7492 135.059 56.7933 135.113 56.8374 135.113C57.7197 135.491 57.808 136.95 56.8816 137.329C56.8374 137.329 56.7933 137.383 56.7492 137.383C56.3522 137.545 55.8228 137.275 55.6463 136.842C55.4699 136.518 55.3816 136.14 55.5581 135.761Z",
    fill: "#E3E5FC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5752_33455",
    x1: 15.9317,
    y1: 96.5256,
    x2: 91.2076,
    y2: 96.5256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5752_33455",
    x1: 15.9317,
    y1: 109.915,
    x2: 91.2083,
    y2: 109.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5752_33455",
    x1: 15.9317,
    y1: 123.303,
    x2: 91.2082,
    y2: 123.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5752_33455",
    x1: 134.405,
    y1: 76.2844,
    x2: 147.44,
    y2: 76.2844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5752_33455",
    x1: 176.514,
    y1: 80.8841,
    x2: 193.078,
    y2: 80.8841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5752_33455",
    x1: 218.622,
    y1: 89.161,
    x2: 235.186,
    y2: 89.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5752_33455",
    x1: 244.166,
    y1: 89.161,
    x2: 277.295,
    y2: 89.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5752_33455",
    x1: 109.556,
    y1: 157.134,
    x2: 267.122,
    y2: 173.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6800BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36CCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5752_33455",
    x1: 264.743,
    y1: 171.413,
    x2: 343.118,
    y2: 203.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5752_33455",
    x1: 202.469,
    y1: 137.04,
    x2: 267.439,
    y2: 172.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5752_33455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 333.856,
    height: 186.79,
    fill: "white",
    transform: "translate(18.1443 0.705078)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5752_33455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.613,
    height: 90.4369,
    fill: "white",
    transform: "translate(199.663 122.074) rotate(-2.47822)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5752_33455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.754,
    height: 120.695,
    fill: "white",
    transform: "matrix(-1 0 0 1 323.164 180.6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_5752_33455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130.639,
    height: 160.04,
    fill: "white",
    transform: "translate(0 81.3086)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_5752_33455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125.067,
    height: 153.214,
    fill: "white",
    transform: "translate(24.7656 71.4492)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllufakos);
export default __webpack_public_path__ + "static/media/illufakos.bb20241f.svg";
export { ForwardRef as ReactComponent };